import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDateTime,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";
const PensionRegulatorsExpansionHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Translations[]/Label", {
      getString: (item) => {
        return translate2(item, "Label");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.act",
    type: new ODataString("Translations[]/Act", {
      getString: (item) => {
        return translate2(item, "Act");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new ODataHeader({
  //   title: "headers.pension_regulators.original_date",
  //   type: new ODataDate("OriginalDate"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  // }),
  new ODataHeader({
    title: "headers.pension_regulators.reform_date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.user",
    type: new ODataString("User"),
    visible: true,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.activity",
    type: new ODataString("Activity", {
      getString: (item) => i18n.t("enums." + item.Activity),
    }),
    visible: true,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    title: "globals.timestamp",
    type: new ODataDateTime("Timestamp"),
    visible: true,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
];
export default PensionRegulatorsExpansionHeaders;
